"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSnapToN = createSnapToN;
exports.createSnapToZero = createSnapToZero;
exports.disable = disable;
exports.none = none;

var _math = require("./math.js");

/**
 * @module ol/rotationconstraint
 */

/**
 * @typedef {function((number|undefined), boolean=): (number|undefined)} Type
 */

/**
 * @param {number|undefined} rotation Rotation.
 * @return {number|undefined} Rotation.
 */
function disable(rotation) {
  if (rotation !== undefined) {
    return 0;
  } else {
    return undefined;
  }
}
/**
 * @param {number|undefined} rotation Rotation.
 * @return {number|undefined} Rotation.
 */


function none(rotation) {
  if (rotation !== undefined) {
    return rotation;
  } else {
    return undefined;
  }
}
/**
 * @param {number} n N.
 * @return {Type} Rotation constraint.
 */


function createSnapToN(n) {
  var theta = 2 * Math.PI / n;
  return (
    /**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */
    function (rotation, opt_isMoving) {
      if (opt_isMoving) {
        return rotation;
      }

      if (rotation !== undefined) {
        rotation = Math.floor(rotation / theta + 0.5) * theta;
        return rotation;
      } else {
        return undefined;
      }
    }
  );
}
/**
 * @param {number} [opt_tolerance] Tolerance.
 * @return {Type} Rotation constraint.
 */


function createSnapToZero(opt_tolerance) {
  var tolerance = opt_tolerance || (0, _math.toRadians)(5);
  return (
    /**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */
    function (rotation, opt_isMoving) {
      if (opt_isMoving) {
        return rotation;
      }

      if (rotation !== undefined) {
        if (Math.abs(rotation) <= tolerance) {
          return 0;
        } else {
          return rotation;
        }
      } else {
        return undefined;
      }
    }
  );
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUdBOztBQUhBOzs7O0FBS0E7Ozs7QUFJQTs7OztBQUlNLFNBQVVBLE9BQVYsQ0FBa0JDLFFBQWxCLEVBQTBCO0VBQzlCLElBQUlBLFFBQVEsS0FBS0MsU0FBakIsRUFBNEI7SUFDMUIsT0FBTyxDQUFQO0VBQ0QsQ0FGRCxNQUVPO0lBQ0wsT0FBT0EsU0FBUDtFQUNEO0FBQ0Y7QUFFRDs7Ozs7O0FBSU0sU0FBVUMsSUFBVixDQUFlRixRQUFmLEVBQXVCO0VBQzNCLElBQUlBLFFBQVEsS0FBS0MsU0FBakIsRUFBNEI7SUFDMUIsT0FBT0QsUUFBUDtFQUNELENBRkQsTUFFTztJQUNMLE9BQU9DLFNBQVA7RUFDRDtBQUNGO0FBRUQ7Ozs7OztBQUlNLFNBQVVFLGFBQVYsQ0FBd0JDLENBQXhCLEVBQXlCO0VBQzdCLElBQU1DLEtBQUssR0FBSSxJQUFJQyxJQUFJLENBQUNDLEVBQVYsR0FBZ0JILENBQTlCO0VBQ0E7SUFDRTs7Ozs7SUFLQSxVQUFVSixRQUFWLEVBQW9CUSxZQUFwQixFQUFnQztNQUM5QixJQUFJQSxZQUFKLEVBQWtCO1FBQ2hCLE9BQU9SLFFBQVA7TUFDRDs7TUFFRCxJQUFJQSxRQUFRLEtBQUtDLFNBQWpCLEVBQTRCO1FBQzFCRCxRQUFRLEdBQUdNLElBQUksQ0FBQ0csS0FBTCxDQUFXVCxRQUFRLEdBQUdLLEtBQVgsR0FBbUIsR0FBOUIsSUFBcUNBLEtBQWhEO1FBQ0EsT0FBT0wsUUFBUDtNQUNELENBSEQsTUFHTztRQUNMLE9BQU9DLFNBQVA7TUFDRDtJQUNGO0VBakJIO0FBbUJEO0FBRUQ7Ozs7OztBQUlNLFNBQVVTLGdCQUFWLENBQTJCQyxhQUEzQixFQUF3QztFQUM1QyxJQUFNQyxTQUFTLEdBQUdELGFBQWEsSUFBSSxxQkFBVSxDQUFWLENBQW5DO0VBQ0E7SUFDRTs7Ozs7SUFLQSxVQUFVWCxRQUFWLEVBQW9CUSxZQUFwQixFQUFnQztNQUM5QixJQUFJQSxZQUFKLEVBQWtCO1FBQ2hCLE9BQU9SLFFBQVA7TUFDRDs7TUFFRCxJQUFJQSxRQUFRLEtBQUtDLFNBQWpCLEVBQTRCO1FBQzFCLElBQUlLLElBQUksQ0FBQ08sR0FBTCxDQUFTYixRQUFULEtBQXNCWSxTQUExQixFQUFxQztVQUNuQyxPQUFPLENBQVA7UUFDRCxDQUZELE1BRU87VUFDTCxPQUFPWixRQUFQO1FBQ0Q7TUFDRixDQU5ELE1BTU87UUFDTCxPQUFPQyxTQUFQO01BQ0Q7SUFDRjtFQXBCSDtBQXNCRCIsIm5hbWVzIjpbImRpc2FibGUiLCJyb3RhdGlvbiIsInVuZGVmaW5lZCIsIm5vbmUiLCJjcmVhdGVTbmFwVG9OIiwibiIsInRoZXRhIiwiTWF0aCIsIlBJIiwib3B0X2lzTW92aW5nIiwiZmxvb3IiLCJjcmVhdGVTbmFwVG9aZXJvIiwib3B0X3RvbGVyYW5jZSIsInRvbGVyYW5jZSIsImFicyJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvcm90YXRpb25jb25zdHJhaW50LmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19